import { render, staticRenderFns } from "./202412.vue?vue&type=template&id=2a21da69&scoped=true&"
import script from "./202412.vue?vue&type=script&lang=js&"
export * from "./202412.vue?vue&type=script&lang=js&"
import style0 from "./202412.vue?vue&type=style&index=0&id=2a21da69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21da69",
  null
  
)

export default component.exports